import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const ModalHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      height: 70,
      backgroundColor: theme.palette.primary.main,
    },
    titleContainer: {
      [theme.breakpoints.up("md")]: {
        paddingLeft: "10%",
      },
    },
    iconItem: {
      paddingRight: 10,
    },
    title: {
      color: "#fff",
      fontSize: "24px",
      "@media (max-width:400px)": {
        fontSize: "18px",
      },
    },
    closeButton: {
      paddingRight: 20,
    },
  }),
);
